import type { QueryClient } from "@tanstack/react-query";

import { interlude } from "@/interlude";

/**
 * Refetches the Data Hub connection and merge state after connecting or
 * disconnecting. Both happen on the Data Hub page, which stays mounted while
 * only its tab changes, so its queries would otherwise keep the old state.
 */
export const invalidateCdhStatus = (queryClient: QueryClient) =>
  Promise.all([
    queryClient.invalidateQueries({
      queryKey: interlude.unifyScopeSetting.getKeyByAlias(
        "getUnifyScopeSetting",
      ),
    }),
    queryClient.invalidateQueries({
      queryKey: interlude.unifyScopeSetting.getKeyByAlias("getUnifyMergeState"),
    }),
  ]);
